import { KeyboardEvent, useMemo } from 'react'
import { EventName } from 'src/context/userProfileContext'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import { useSessionData } from 'src/hook/useSessionData'
import { useTrackEvents } from 'src/context/userProfileContext/hooks'
import { useUserProfile } from '../useUserProfile'
import { OnOpenProfileParams } from './useUserProfileActions.types'

const useUserProfileActions = () => {
  const { user } = useSessionData()
  const { setVisible, setUserUcode, reset } = useUserProfile()
  const { sendOpenProfileEvent } = useTrackEvents({ loggedUserUcode: user?.ucode })
  const isLoggedUser = useMemo(() => Boolean(user?.isLogged), [user])
  useCustomEvent(EventName.OPEN_PROFILE, onOpenProfile)
  useCustomEvent(EventName.CLOSE_PROFILE, onCloseProfile)

  function onOpenProfile({ ucode, componentName }: OnOpenProfileParams) {
    if (!isLoggedUser) {
      return
    }

    closeDropdownMenus()
    setUserUcode(ucode || user?.ucode)
    setVisible(true)

    if (componentName) {
      sendOpenProfileEvent({ componentName })
    }
  }

  function onCloseProfile() {
    setVisible(false)
    setTimeout(() => reset(), 500)
  }

  function onKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    if (event.key === 'Escape') {
      onCloseProfile()
    }
  }

  function closeDropdownMenus() {
    document.body.click()
  }

  return {
    isLoggedUser,
    onOpenProfile,
    onCloseProfile,
    onKeyDown
  }
}

export default useUserProfileActions
